import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/var/www/pinuprompt.site/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/pinuprompt.site/src/app/prompt/components/PromptDetailView.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/pinuprompt.site/src/components/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/pinuprompt.site/src/components/ui/AppLogo.tsx");
